import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Avatar from '../../Avatar';
import { currentProjectIdSelector } from '../../../reducers/projects';
import { getUserLabel } from './helpers';
import InlineValue from '../InlineValue';
import { UserActions } from '../../../actions/user';

const projectsUsersSelector = (state) => state.projectsUsers.get('projectsUsers');
const usersMapSelector = (state) => {
  const currentProjectId = currentProjectIdSelector(state);
  const projectUsers = projectsUsersSelector(state).getIn([currentProjectId], []);
  const usersMap = state.users.get('users');
  const projectUsersMap = usersMap.filter((u, k) => projectUsers.has(k));

  if (projectUsersMap.size === 0) return null;
  return projectUsersMap;
};

const DisplayComponentSelector = createSelector(
  [currentProjectIdSelector, usersMapSelector],
  (currentProjectId, usersMap) => ({
    currentProjectId,
    usersMap,
  })
);

@connect(DisplayComponentSelector)
export default class Display extends PureComponent {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func,
    toggleEditor: PropTypes.func,
    usersMap: PropTypes.object,
    userMode: PropTypes.string,
    value: PropTypes.string,
  };

  componentDidMount = () => {
    const { dispatch, currentProjectId } = this.props;
    return dispatch(UserActions.getProjectUsers(currentProjectId));
  }

  render = () => {
    const {
      toggleEditor,
      usersMap,
      userMode,
      value,
    } = this.props;

    // Extract the name and avatar to be displayed
    let displayName = 'Unknown';
    let avatar = null;
    if (!value || (value === 'Unassigned')) {
      displayName = <span className="clickToEdit">Unassigned</span>;
    } else if (usersMap) {
      const user = usersMap.get(value);
      if (user) {
        avatar = <Avatar className="mr-1" user={user} width="37" height="37" rounded />;
        const userName = getUserLabel(user);
        if (userName) displayName = userName;
      }
    }

    const renderDisplayName = (
      <div style={{ display: 'inline-block' }}>
        {avatar}
        {displayName}
      </div>
    );

    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {renderDisplayName}
      </InlineValue>
    );

    return displayValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/UserSelect/Display.js